import {
  APPROVAL_SURGE_FILE_UPLOAD,
  APPROVAL_SURGE_FILE_UPLOAD_SUCCESS,
  APPROVAL_SURGE_FILE_UPLOAD_ERROR,
  APPROVAL_SURGE_FILE_UPLOAD_EMPTY,
} from '../../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ApproveSurgeFileUpload = (state = initialState, action) => {
  switch (action.type) {
    case APPROVAL_SURGE_FILE_UPLOAD:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_SURGE_FILE_UPLOAD_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case APPROVAL_SURGE_FILE_UPLOAD_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case APPROVAL_SURGE_FILE_UPLOAD_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ApproveSurgeFileUpload;
